<div class="layoutBlock searchresultListContainer">

	<!-- Linke Seite: -->
	<div class="searchresultListSideLeft">
    	<div class="circle-icon">
      		<div>
				<!-- TODO: Image als Input übergeben -->
        		<img hisImage="{{image}}" class="inlineicon" [title]="imageTitle | hisUi">
      		</div>
    	</div>
  	</div>

  	<!-- Mitte: der Inhalt der Kind-Komponente wird von außen eingefügt -->
	<div class="searchresultListpageCenter">
	    <div class="vcardSearchresult">
  		<h2>{{pageTitle | hisUi}}</h2>
  		
	    @if (bannerTemplate) {
	       <ng-container [ngTemplateOutlet]="bannerTemplate"></ng-container>
	    }
  		
  		@if (showSwitchListToTableButton) {
	  	<button (click)="switchListTable()" class="transparent bottomRight">
	        <img hisImage="table" class="inlineicon" [title]=" ">
	        <span>{{'view.unit_template.connect_orgunits_index' | hisUi}}</span>
		</button>
		}
  
    	<div class="clearerSpaceAbove1Em"></div>

        <span appScrollwithme class="genericSearchButtons">
        	<!-- Standard buttons -->
        	@if (showNewSearchButton) {
	          <button type="submit" iconPos="left" (click)="hisSearchResultComponent.newSearch()">
	            <span>{{'de.his.javang.newsearch'|hisUi}}</span>
	          </button>
                    }
	        @if (showChangeSearchButton) {
	          <button type="submit" iconPos="left" (click)="hisSearchResultComponent.changeSearch()">
	            <span>{{'de.his.javang.changesearch'|hisUi}}</span>
	          </button>
	        }
        </span>

      	@if (hisSearchResultComponent.doShowJobStarter) {
	        <his-job-starter
	          [key]="hisSearchResultComponent.jobStarterKey"
	          [search]="hisSearchResultComponent.search"
	          [searchConfigFile]="hisSearchResultComponent.searchConfigFile"
	          [selectedOptions]="hisSearchResultComponent.selectedOptions">
        	</his-job-starter>
      }
      
        <div class="clearerSpaceAbove1Em"></div>
        </div>

    	<div class="clearerSpaceAbove1Em"></div>
    	<div class="clearerSpaceAbove1Em"></div>
        
        @if (showTableDataScroller) {
		<div class="labelVcardSearchresult">
			<span>
		        {{'de.his.faces.tags.table.datascroller.numRowsFound.label' | hisUi}}
		        {{'de.his.faces.tags.table.datascroller.numRowsFound.records' |	hisUi: records}} |
		        {{'de.his.faces.tags.table.datascroller.numRowsFound.page' | hisUi: currentPage : totalPage}}
		    </span>
		</div>
        }
        
	    @if (showResultRowsLimitedMessage && hisSearchResultComponent.resultRowsLimitedMessage) {
	      <div class="infoMessage">{{ hisSearchResultComponent.resultRowsLimitedMessage | hisUi : hisSearchResultComponent.maxResultRows }}</div>
	    }
  
		<div class="searchResultList">
	        <ng-content></ng-content>
	    </div>
        
        @if (showPaginator) {
		<div class="ui-paginator">
	        <p-paginator [first]="first" [rows]="rowsPerPage" [totalRecords]="records" (onPageChange)="paginate($event)"></p-paginator>
	    </div>
    	<p></p>
    	}

        <div class="genericSearchButtons">
       	
        <!-- Standard buttons -->
    	@if (showNewSearchButton) {
        <button type="submit" iconPos="left" (click)="hisSearchResultComponent.newSearch()">
          <span>{{'de.his.javang.newsearch'|hisUi}}</span>
        </button>
    	}
    	@if (showChangeSearchButton) {
        <button type="submit" iconPos="left" (click)="hisSearchResultComponent.changeSearch()">
          <span>{{'de.his.javang.changesearch'|hisUi}}</span>
    	</button>
    	}
		</div>
  	</div>
  
	<!-- Rechte Seite: -->
	<div class="searchresultListpageRight">
    <!--Platzhalter für leere rechte Spalte, wird ausgeblendet, wenn Breakpoint SMALL -->
  </div>

</div>
